import queries from '@apis/queries';
import UserApi from '@apis/user/UserApi';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@stackflow/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import useUserDetail from './useUserDetail';

function useNickname() {
    const { t } = useTranslation('accountSetting');
    const [nickname, setNickname] = useState<string>('');
    const toast = useToast();
    const userDetail = useUserDetail();
    const nicknameHelperText = nickname.length > 16
        ? t('helper.nicknameMaxLength16') : '';
    const { push } = useFlow();
    const queryClient = useQueryClient();
    const { mutate } = useMutation({
        mutationFn: UserApi.updateNickname,
        onSuccess() {
            queryClient.invalidateQueries({ queryKey: queries.user._def });
            push('NickNameChangeModal', {});
        },
        onError(e) {
            console.error(e);
            toast.error(t('toast.nicknameError'));
        },
    });
    const handleUpdateNickname = async () => {
        if (nicknameHelperText.length > 20) {
            toast.error(t('toast.nicknameMaxLength'));
            return;
        }
        if (nickname.length === 0) {
            toast.error(t('toast.nicknameRequired'));
            return;
        }
        mutate(nickname);
    };

    useEffect(() => {
        if (userDetail) {
            setNickname(userDetail.nickname);
        }
    }, [userDetail]);
    return {
        nickname,
        setNickname,
        handleUpdateNickname,
        nicknameHelperText,
    };
}

export default useNickname;
